import { defineComponent as _defineComponent } from 'vue'
import { BaseText, Heading } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalContent',
  props: {
    imageSrc: null,
    imageAlt: null,
    title: null,
    description: null
  },
  setup(__props: any) {



return { __sfc: true,BaseText, Heading, NebraskaColors }
}

})